var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment } from "react";
import { Menu } from "@headlessui/react";
import { NavLink } from "react-router-dom";
import { DropdownMenuItemBase } from "./styles";
export var DropdownMenuItem = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Menu.Item, __assign({ as: 
        // If menu item is link but is disabled, render component as fragment to prevent navigation.
        props.asLink && !props.disabled ? NavLink : Fragment }, props), function (_a) {
        var active = _a.active, disabled = _a.disabled;
        return (React.createElement(DropdownMenuItemBase, { active: active, disabled: disabled }, children));
    }));
};
